import * as React from 'react';
import { observer } from 'mobx-react';
import { Maybe } from 'maybeasy';
import * as style from './style.module.css';
import { AlreadyTranslated, AlreadyTranslatedText } from '@execonline-inc/translations';

interface Props {
  label: Maybe<AlreadyTranslatedText>;
  htmlFor?: string;
}

const Label: React.FC<Props> = ({ label, htmlFor }) => {
  return label
    .map((l) => (
      <label className={style.label} htmlFor={htmlFor}>
        <AlreadyTranslated content={l} />
      </label>
    ))
    .getOrElseValue(<></>);
};

export default observer(Label);
